<template>
    <div>
        <p class="first_content">
            <span class="requirements" :class="{'ishide': !ismock}"><span class="require_title">作业要求：</span>{{description}}</span>
            <span class="comment">
                <span v-if="ismock" class="requirement_detail" @click='look_detail'>详情</span>
                <!-- <el-button plain size="middle" @click='default_comment'>默认语点评</el-button> -->
                <el-button plain size="middle" @click='ueditor_flag = true' v-if='getOverall'>整体点评</el-button>
            </span>
        </p>
        <div class="content_box">
            <div class="content_left">
                <p class="main_papername">{{papername}}</p>
                <p class="main_rate" v-if='total_count'>答对：<span class="correct_ques">{{correct_count}}/{{total_count}}</span>
                  <span class="proportion">正确率：<span class="correct_ques" v-if='total_count'>{{(correct_count/total_count*100).toFixed()}}%</span><span class="correct_ques" v-else>0%</span></span>
                </p>
                <p class="main_rate" v-else>总题量：<span class="correct_ques">{{total_num}}</span></p>
                <div v-for='i in data'>
                    <div v-if='i.question_pattern == 1'>
                        <p>{{i.block_name}}</p>
                        <p>答对：<span class="correct_ques">{{i.correct_num}}/{{i.total_num}}</span>
                            <span class="proportion">正确率：<span class="correct_ques">{{(i.correct_num/i.total_num*100).toFixed()}}%</span></span>
                            <span class="proportion pointde">得分：<span class="correct_ques">{{i.user_score}}/{{i.total_score}}</span></span>
                        </p>
                    </div>
                    <div v-if='i.question_pattern == 2'>
                        <p>{{i.block_name}}</p>
                        <p>总题量：<span class="correct_ques">{{i.total_num}}</span>
                            <span v-if="i.ZGCorrectScore && i.ZGNotCorrectScore" class="proportion pointde">得分：<span class="correct_ques">{{i.ZGCorrectUserScore}}/{{i.ZGScore}}</span>
                              <span class="scoring_criteria">主观题满分{{i.ZGScore}}，得分详情：<br/>
                                (1)人工批改部分：满分{{i.ZGCorrectScore}}分，得分：{{i.ZGCorrectUserScore}}分<br/>
                                (2)未进行人工批改部分：满分{{i.ZGNotCorrectScore}}分，统一记为0分。
                              </span>
                            </span>
                            <span v-else-if="i.ZGCorrectScore" class="proportion pointde">得分：<span class="correct_ques">{{i.ZGCorrectUserScore}}/{{i.ZGCorrectScore}}</span>
                              <span class="scoring_criteria">主观题满分{{i.ZGScore}}，得分详情：<br/>
                                (1)人工批改部分：满分{{i.ZGCorrectScore}}分，得分：{{i.ZGCorrectUserScore}}分<br/>
                              </span>
                            </span>
                            <span v-else-if="i.ZGNotCorrectScore" class="proportion pointde">得分：<span class="correct_ques">0/{{i.ZGNotCorrectScore}}</span>
                              <span class="scoring_criteria">主观题满分{{i.ZGScore}}，得分详情：<br/>
                                (1)未进行人工批改部分：满分{{i.ZGNotCorrectScore}}分，统一记为0分。
                              </span>
                            </span>
                        </p>
                    </div>
                    <div v-if='i.question_pattern == 3'>
                        <p>{{i.block_name}}</p>
                        <p>答对：<span class="correct_ques">{{i.total_num}}</span>
                            <span class="proportion">正确率：<span class="correct_ques">{{(i.correct_num/i.total_num*100).toFixed()}}%</span></span>
                            <span class="proportion pointde">得分：<span class="correct_ques">{{i.user_score}}/{{i.total_score}}</span>
                              <span class="scoring_criteria">主观题满分{{i.ZGScore}}，得分详情：(1)人工批改部分：满分{{i.ZGCorrectScore}}分，得分：{{i.ZGCorrectUserScore}}分{{i.ZGNotCorrectScore}}</span>
                            </span>
                        </p>
                    </div>
                    <p>
                        <span class="item_question" v-for='(item, index) in i.question_list' :class='(item.form == 4 || item.user_answer == "")?"item_form":""'>{{index+1}}
                            <span v-if='item.is_correct == 1&&item.form !=4' class="answers"></span>
                            <span v-else-if='item.form !=4 && item.user_answer' class="answers answered"></span>
                            <span v-if='item.is_signed == 1' class="signed"></span>
                        </span>
                    </p>
                    <div v-if="i.issub">
                      <p>试题考点
                        <span class="open_content" @click="point_flag = !point_flag">{{point_flag == false? '展开':'收起'}}<i :class="point_flag==false?'open_icon':'close_icon'"></i></span>
                      </p>
                      <div v-if='point_flag'>
                        <p v-for='(j, idx) in i.question_list'>
                          <span v-if='j.subject' :class="{'import_tip':!j.is_correct&&j.form!=4}">{{idx+1}}、{{j.subject}}</span>
                        </p>
                      </div>
                    </div>
                    <div v-else>
                      <p>试题考点</p>
                      <p>无</p>
                    </div>
                </div>
            </div>
            <!-- <div class="content_right">
              <div class="content_right__wraper">
                <comments id="ueditor_comments" ref="ueditor_comments" :allCommentsDialog="false">
                  <p>整体点评</p>
                </comments>
              </div>
            </div> -->
        </div>
        <el-dialog title="默认语点评" :visible.sync="default_flag">
            <div class="defaultTip">（填写默认语后，作业全部题目都使用当前评语）</div>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入"
              :readonly="!can_edit"
              v-model="defaultComment">
            </el-input>
            <div class="defaultCommentError" v-if="defaultComment === ''">请填写默认点评</div>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="default_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments('default')">应用</el-button>
            </span>
        </el-dialog>
        <el-dialog title="整体点评" :append-to-body="true" :visible.sync="ueditor_flag">
            <p style="position: relative;">
              <comments id="ueditor_comments2" ref="ueditor_comments2" :allCommentsDialog="true">
              </comments>
            </p>
            <span slot="footer" class="dialog-footer" v-show="can_edit">
              <el-button @click="ueditor_flag = false">取 消</el-button>
              <el-button type="primary" @click="saveComments">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import VideoPlayer from '@/components/video-player'
    import Comments from '@/components/ueditor/comments'
    import global_ from "../../global/index"

    export default {
        data() {
          return {
                description: window.localStorage.getItem('description'),
                papername: '',
                data: null,
                allCommentsDialog: false,
                ueditor_flag: false,
                default_flag: false,
                total_num: 0,
                total_count: 0,
                correct_count: 0,
                defaultComment: '',
                can_edit: true,
                point_flag: false,
                ismock: this.$route.params.object_type == 2?false: true
          };
        },
        components: {
          Comments
        },
        computed: {
          comments: {
            get () {
              return this.$store.state.app.comments
            },
            set (value) {
              this.$store.commit('setComments', value)
            }
          },
          upload: {
            get () {
              return this.$store.state.app.upload
            },
            set (value) {
              this.$store.commit('setUpload', value)
            }
          },
          audio: {
            get () {
              return this.$store.state.app.audio
            },
            set (value) {
              this.$store.commit('setAudio', value)
            }
          },
          attachmentFilesList: {
            get () {
              return this.$store.state.app.attachmentFilesList
            },
            set (value) {
              this.$store.commit('setAttachmentFilesList', value)
            }
          },
          getOverall () {
            return this.$store.state.app.overall
          }
        },
        methods:{
            look_detail(){
                this.$alert(window.localStorage.getItem('description'), '作业要求', {
                    showConfirmButton: false
                });
            },
            default_comment(){
              this.default_flag = true
              this.getExerciseCorrectRet()
            },
            // 获取默认点评内容
            getExerciseCorrectRet () {
              this.defaultComment = ''
              const { exercise_id, record_id, object_type } = this.$route.params
              let params = {
                exercise_id: exercise_id,
                record_id: record_id,
                comment_type: 1,
                level_no: 0,
                comment_object_id: 0,
                object_type: object_type
              }
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.GETEXERCISECORRECTRET(params).then(res => {
                if (res.retcode === 0) {
                  let result = res.data
                  this.defaultComment = result.remark
                }
              })
            },
            getcontent(){
              if (this.$route.params.object_type == 2) {
                this.$api.GETEXERCISEMOCKREPORT({
                    record_id: this.$route.params.record_id,
                    object_id: this.$route.params.object_id,
                    exercise_id: this.$route.params.exercise_id,
                    correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then((res) => {
                    if(res.retcode == 0){
                        this.papername = res.data.paper_name
                        this.data = res.data.list
                        for(let i=0;i<res.data.list.length;i++){
                          if(res.data.list[i].question_pattern!=2){
                            this.total_count = res.data.total_num
                            this.correct_count = res.data.correct_num
                          } else {
                            this.total_num += res.data.list[i].total_num
                          }
                        }
                        for (var i in this.data) {
                          let that = this
                          this.data[i].question_list.some(function(item) {
                            that.data[i].issub = item.subject!=''
                          })
                        }
                    }
                })
              } else {
                this.$api.GETEXERCISEPAPERREPORT({
                    record_id: this.$route.params.record_id,
                    object_id: this.$route.params.object_id,
                    exercise_id: this.$route.params.exercise_id,
                    correct_from: this.$route.query.correct_from ? this.$route.query.correct_from : 1
                }).then((res) => {
                    if(res.retcode == 0){
                        this.papername = res.data.paper_name
                        this.data = res.data.list
                        for(let i=0;i<res.data.list.length;i++){
                          if(res.data.list[i].question_pattern!=2){
                            this.total_count = res.data.total_num
                            this.correct_count = res.data.correct_num
                          } else {
                            this.total_num += res.data.list[i].total_num
                          }
                        }
                        for (var i in this.data) {
                          let that = this
                          this.data[i].question_list.some(function(item) {
                            that.data[i].issub = item.subject!=''
                          })
                        }
                    }
                })
              }
            },
            saveComments (flag) {
              if (flag === 'default') {
                if (this.defaultComment === '') {
                  return
                }
              }
              const {
                comment_type,
                exercise_id,
                record_id,
                correct_user,
                object_type,
                object_id,
                tiku_user_id,
                sso_id,
                correct_score,
                level_no,
                comment_object_id
              } = this.$route.params
              let params = {
                comment_type: 0,
                exercise_id: exercise_id,
                record_id: record_id,
                correct_user: correct_user,
                object_type: object_type,
                object_id: object_id,
                tiku_user_id: tiku_user_id,
                sso_id: sso_id,
                correct_score: correct_score,
                level_no: 0,
                comment_object_id: ''
              }
              if (flag === 'default') {
                params.comment_text = this.defaultComment
                params.comment_type = 1 // 默认语点评
              } else {
                params.comment_text = this.comments
              }
              let appendant = []
              if (this.upload.media_id) {
                let uploadObj = {
                  file_url: this.upload.url,
                  file_type: this.upload.type,
                  is_lock: 0,
                  media_id: this.upload.media_id,
                  file_name: ''
                }
                // uploadObj = JSON.stringify(uploadObj)
                appendant.push(uploadObj)
              }
              if (this.audio.media_id) {
                let audioObj = {
                  file_url: this.audio.url,
                  file_type: this.audio.type,
                  is_lock: 0,
                  media_id: this.audio.media_id,
                  file_name: ''
                }
                appendant.push(audioObj)
              }
              if (this.attachmentFilesList.length > 0) {
                this.attachmentFilesList.map((item) => {
                  item.pop_flag = 0
                })
                appendant = [...appendant, ...this.attachmentFilesList]
              }
              params.appendant = JSON.stringify(appendant)
              console.log(params)
              params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
              this.$api.SAVECOMMENT(params).then(res => {
                if (res.retcode === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                    onClose: () => {
                    }
                  });
                  this.ueditor_flag = false
                  this.default_flag = false
                } else {
                  this.$message.error(res.message)
                }
              })
            }
        },
        created () {
          if (this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) != -1) {
            this.can_edit = true
          } else {
            this.can_edit = false
          }
        },
        mounted () {
            this.getcontent()
        }
    }
</script>

<style lang="less" scoped>
.el-dialog__wrapper{
  z-index: 10;
}
.v-modal{
  z-index: 9!important;
}
    .first_content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 10px;
        margin: 0;
        .requirements{
            width: 680px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #7d829a;
            font-size: 14px;
            .require_title{
                color: #2a2e3d;
                font-weight: bold;
            }
        }
        .comment{
            float: right;
            .requirement_detail{
                font-size: 14px;
                margin-right: 15px;
                color: #6594fe;
                cursor: pointer;
            }
        }
        .el-button{
            color: #6594fe;
            border: 1px solid #6594fe;
        }
    }
    .content_box{
        display: flex;
        .content_left{
            flex: 1;
            margin-top: 30px;
            font-size: 14px;
            .correct_ques{
                color: #6594fe;
                font-weight: bold;
            }
            .main_papername{
                text-align: center;
                font-weight: bold;
                font-size: 16px;
                margin: 0;
            }
            .main_rate{
                text-align: center;
            }
            .proportion{
                margin-left: 20px;
            }
            .pointde {
                position: relative;
                cursor: pointer;
                .scoring_criteria {
                    position: absolute;
                    left: -100px;
                    bottom: 20px;
                    width: 362px;
                    color: #ffffff;
                    border-radius: 4px;
                    background: rgba(0, 0, 0, .6);
                    padding: 6px 20px;
                    display: none;
                }
            }
            .pointde:hover .scoring_criteria {
                display: block;
            }
            .item_question{
                position: relative;
                display: inline-block;
                width: 30px;
                height: 30px;
                color: #6594fe;
                background: #f0f0f0;
                text-align: center;
                line-height: 30px;
                border-radius: 4px;
                border: 1px solid #f0f0f0;
                margin-right: 10px;
                margin-bottom: 10px;
                .answers{
                    position: absolute;
                    top: -1px;
                    left: -1px;
                    width: 12px;
                    height: 12px;
                    background: url(../../../static/images/correct.png);
                    background-size: cover;
                }
                .answered{
                    background: url(../../../static/images/wrong.png);
                }
                .signed{
                    position: absolute;
                    right: -5px;
                    top: -5px;
                    width: 12px;
                    height: 12px;
                    background: url(../../../static/images/flag.png);
                    background-size: cover;
                }
            }
            .item_form{
              background: #fff;
              color: #7d829a;
            }
        }
        .content_right{
            width: 370px;
            margin-top: 30px;
            border-left: 1px solid #e5e5e5;
            .content_right__wraper{
              margin-left: 27px;
              width: 342px;
            }
        }
    }
    .el-textarea__inner{
        resize:none;
    }
    .default_area{
        width: 388px;
        height: 100px;
        padding: 10px;
        outline: none;
        resize:none;
    }
    .open_content{
      font-size: 12px;
      float: right;
      position: relative;
      margin-right: 30px;
      cursor: pointer;
      .open_icon{
        display: inline-block;
        position: absolute;
        margin-left: 5px;
        width: 12px;
        height: 7px;
        top: 5px;
        background: url(../../../static/images/down.png) no-repeat;
      }
      .close_icon{
        display: inline-block;
        position: absolute;
        margin-left: 5px;
        width: 12px;
        height: 7px;
        top: 5px;
        background: url(../../../static/images/down.png) no-repeat;
        transform: rotate(180deg);
      }
    }
    .import_tip {
      color: red;
    }
    .ishide {
      visibility: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/homework-main/index.vue